import React from 'react';
export const SecuritySafe = () => /*#__PURE__*/React.createElement("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.9998 12.5C13.1044 12.5 13.9998 11.6046 13.9998 10.5C13.9998 9.39543 13.1044 8.5 11.9998 8.5C10.8953 8.5 9.99985 9.39543 9.99985 10.5C9.99985 11.6046 10.8953 12.5 11.9998 12.5ZM11.9998 12.5V15.5M20.9099 11.12C20.9099 16.01 17.3599 20.59 12.5099 21.93C12.1799 22.02 11.8198 22.02 11.4898 21.93C6.63984 20.59 3.08984 16.01 3.08984 11.12V6.72997C3.08984 5.90997 3.70986 4.97998 4.47986 4.66998L10.0498 2.39001C11.2998 1.88001 12.7098 1.88001 13.9598 2.39001L19.5298 4.66998C20.2898 4.97998 20.9199 5.90997 20.9199 6.72997L20.9099 11.12Z",
  stroke: "currentColor",
  strokeWidth: "1.5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));